// extracted by mini-css-extract-plugin
export default {"tile":"tile--mp-Gon_4","badge":"badge--mp-yXDNY","content":"content--mp-CV3sq","title":"title--mp-Jd0qd","subtitle":"subtitle--mp-IqKGh"};